import { CircularProgress, Typography, Button, Box } from "@mui/material";

import Lottie from "react-lottie-player";
import { useNavigate } from "react-router-dom";

import EmptyAnimation from "assets/lotties/empty.json";
import ErrorAnimation from "assets/lotties/error.json";
import NoMoreData from "assets/lotties/noMoreData.json";

import { buttonStyle, lottieStyle, paperStyles } from "./styles";

const ANIMATIONS = {
  error: ErrorAnimation,
  data: NoMoreData,
  empty: EmptyAnimation,
  unverifiedEmail: ErrorAnimation,
};

/**
 * Renders a full screen loading spinner based on theme background
 * @returns JSX Element
 */
interface FullScreenInitProps {
  loading?: boolean;
  animation?: "error" | "data" | "empty" | "unverifiedEmail" | undefined;
  hideBackButton?: boolean;
  height?: string;
  displayText?: string;
}

const FullScreenInit = ({
  loading = false,
  animation,
  hideBackButton = false,
  height,
  displayText = "No results to display",
}: FullScreenInitProps) => {
  const navigate = useNavigate();

  if (loading)
    return (
      <Box sx={{ ...paperStyles, height: height || "unset" }}>
        <CircularProgress />
      </Box>
    );

  return (
    <Box sx={{ ...paperStyles, height: height || "unset" }}>
      {animation && (
        <Lottie
          play
          style={lottieStyle}
          animationData={ANIMATIONS[animation]}
        />
      )}
      {animation === "error" && (
        <>
          <Typography textAlign="center" variant="h5" marginBottom={2}>
            Oops! Something went wrong.
          </Typography>
        </>
      )}
      {animation === "unverifiedEmail" && (
        <>
          <Typography textAlign="center" variant="h5" marginBottom={2}>
            Your email is not verified.
          </Typography>
          <Typography textAlign="center" variant="h5" marginBottom={2}>
            Please verify your email to continue.
          </Typography>
        </>
      )}
      <Typography textAlign="center" variant="h5" mt={3}>
        {displayText || ""}
      </Typography>
      {!hideBackButton && (
        <Button
          onClick={() => navigate(-1)}
          variant="outlined"
          sx={buttonStyle}
        >
          Go Back
        </Button>
      )}
    </Box>
  );
};

export default FullScreenInit;
